import { render, staticRenderFns } from "./EventsDetails.vue?vue&type=template&id=4d2ab994&scoped=true&"
import script from "./EventsDetails.vue?vue&type=script&lang=js&"
export * from "./EventsDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventsDetails.vue?vue&type=style&index=0&id=4d2ab994&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ab994",
  null
  
)

export default component.exports